import { CognitoUserPool } from 'amazon-cognito-identity-js';

// Environment variables are loaded from .env file

export const poolData = {
    UserPoolId: process.env.REACT_APP_USER_POOL_ID || '',
    ClientId: process.env.REACT_APP_CLIENT_ID || ''
};

// Configuration for Cognito Hosted UI
export const hostedUIConfig = {
    domain: process.env.REACT_APP_COGNITO_DOMAIN || '',
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
    clientId: process.env.REACT_APP_CLIENT_ID || '',
    responseType: 'code',
    scope: 'email openid profile'
};

// Configuration is created from environment variables

if (!poolData.UserPoolId || !poolData.ClientId || !hostedUIConfig.domain) {
    console.error('Missing required Cognito configuration');
}

export const userPool = new CognitoUserPool(poolData);
console.log('Cognito User Pool Created:', userPool !== null);

// PKCE helper functions
/**
 * Create a random code_verifier (high-entropy URL-safe string).
 */
export function createCodeVerifier(len = 64): string {
  const bytes = crypto.getRandomValues(new Uint8Array(len));
  return btoa(String.fromCharCode(...bytes))      // base64
           .replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

/**
 * SHA-256 → base64url-encoded code_challenge (S256 method).
 */
export async function createCodeChallenge(v: string): Promise<string> {
  const data = new TextEncoder().encode(v);
  const digest = await crypto.subtle.digest('SHA-256', data);
  const b64 = btoa(String.fromCharCode(...new Uint8Array(digest)));
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

// Helper function to build the Cognito hosted UI URL
export const buildCognitoAuthUrl = async (type: 'login' | 'signup'): Promise<string> => {
    // Format the domain correctly - remove https:// if it's included in the environment variable
    const domain = hostedUIConfig.domain.replace(/^https?:\/\//, '');
    
    // Determine the endpoint based on type
    const endpoint = type === 'signup' ? 'signup' : 'login';
    const baseUrl = `https://${domain}/${endpoint}`;
    
    // Ensure the redirect URI doesn't have duplicate '/auth/callback' paths
    const callbackUri = hostedUIConfig.redirectUri.endsWith('/auth/callback')
        ? hostedUIConfig.redirectUri
        : `${hostedUIConfig.redirectUri}/auth/callback`;
    
    // Use the correctly formatted callback URI
    
    // Generate PKCE code verifier and challenge
    const codeVerifier = createCodeVerifier();
    const codeChallenge = await createCodeChallenge(codeVerifier);
    
    // Store code verifier in session storage to use during token exchange
    sessionStorage.setItem('pkce_code_verifier', codeVerifier);
    
    const queryParams = new URLSearchParams({
        client_id: hostedUIConfig.clientId,
        response_type: hostedUIConfig.responseType,
        scope: hostedUIConfig.scope,
        redirect_uri: callbackUri,
        code_challenge: codeChallenge,
        code_challenge_method: 'S256'
    });

    const authUrl = `${baseUrl}?${queryParams.toString()}`;
    // Auth URL generated with PKCE for security
    return authUrl;
};